// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"vD","ribbon":"vE","title":"vF","genres":"vG"};